/**
 * Saved target price for a position (issue 3, 2026-10-17).
 *
 * The builder's Save writes `target_price_scenarios` linked to the position;
 * the backend surfaces the latest row at GET /api/v1/position-theses/{id}/
 * target-price. An empty object means "none saved yet" — not an error.
 */
import { API_CONFIG } from '../../config/api';
import { getToken } from '../tokenStorage';

export interface SavedTargetPrice {
  id: number;
  symbol: string;
  scenarios: {
    bull: Record<string, number | null> | null;
    base: Record<string, number | null> | null;
    bear: Record<string, number | null> | null;
  };
  probabilities: { bull?: number; base?: number; bear?: number } | null;
  computed: {
    prices?: Record<string, number>;
    weighted?: number;
  } | null;
  probability_weighted_target: number | null;
  rationale: Partial<Record<'bull' | 'base' | 'bear', string>> | null;
  currency: string | null;
  updated_at: string | null;
}

export async function getPositionTargetPrice(
  positionId: number,
): Promise<SavedTargetPrice | null> {
  const token = await getToken();
  const response = await fetch(
    `${API_CONFIG.baseURL}/api/v1/position-theses/${positionId}/target-price`,
    { headers: { Authorization: `Bearer ${token}` } },
  );
  if (!response.ok) throw new Error(`target-price fetch failed (${response.status})`);
  const data = await response.json();
  return data && typeof data === 'object' && data.id != null ? data : null;
}
